import React from 'react';
import { ArrowLeftIcon, SettingsIcon } from 'lucide-react';
import ProfileHeader from '../components/profiles/ProfileHeader';
import ProfileTabs from '../components/profiles/ProfileTabs';
import ProfileDetails from '../components/profiles/ProfileDetails';
const ProfilePage = () => {
  const profile = {
    name: 'Kylian Mbappé',
    username: 'k.mbappe',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
    coverPhoto: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018',
    bio: 'Professional footballer playing as a forward. World Cup winner with France. Speed, skills, and goals are my game.',
    verified: false,
    role: 'Forward',
    sport: 'football',
    location: 'Madrid, Spain',
    website: 'https://www.mbappe.com',
    stats: {
      recommendations: 87,
      postViews: 4580000,
      followers: 124500,
      solicitations: 325
    },
    achievements: [{
      title: 'World Cup Winner',
      icon: 'trophy'
    }, {
      title: 'Golden Boot 2023',
      icon: 'boot'
    }],
    verifications: [{
      title: 'Professional Athlete'
    }],
    currentTeam: {
      name: 'Real Madrid',
      logo: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20'
    },
    profileDetails: {
      position: 'Forward',
      height: '178cm',
      weight: '73kg',
      dominantSide: 'Right',
      experience: '8',
      currentTeam: 'Real Madrid'
    }
  };
  return <div className="bg-white min-h-full pb-16" data-id="element-833">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3 border-b border-gray-100 bg-white sticky top-0 z-10" data-id="element-834">
        <button className="text-gray-800 hover:text-green-600 transition-colors" data-id="element-835">
          <ArrowLeftIcon size={24} data-id="element-836" />
        </button>
        <h1 className="text-lg font-semibold" data-id="element-837">{profile.username}</h1>
        <button className="text-gray-800 hover:text-green-600 transition-colors" data-id="element-838">
          <SettingsIcon size={20} data-id="element-839" />
        </button>
      </div>
      {/* Profile */}
      <ProfileHeader profile={profile} data-id="element-840" />
      {/* Profile Details */}
      <ProfileDetails profile={profile} data-id="element-841" />
      {/* Tabs */}
      <ProfileTabs userId={profile.username} data-id="element-842" />
    </div>;
};
export default ProfilePage;